module.exports = __webpack_public_path__ + "img/sieckFinesseSetup2.c33e403e.png";